import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/quotes/products/new/$id/$policyId/'
)({
  component: NewQuotePageComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.quotes.write']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function NewQuotePageComponent() {
  // vazio de propósito: o layout pai renderiza o formulário e persiste o estado
  return null;
}
